import type { XYChartThresholdIndicatorProps } from '../types/xy-chart-props.js';

/**
 * @public
 */
export const ThresholdIndicator = (props: XYChartThresholdIndicatorProps) =>
  null;

ThresholdIndicator['displayName'] = 'XYChart.ThresholdIndicator';
